/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S5_TitleInputs */

const en_fc_tut_s5_title = /** @type {(inputs: Fc_Tut_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim and tighten`)
};

/**
* | output |
* | --- |
* | "Trim and tighten" |
*
* @param {Fc_Tut_S5_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s5_title = /** @type {((inputs?: Fc_Tut_S5_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S5_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s5_title(inputs)
});
export { fc_tut_s5_title as "fc.tut.s5.title" }